<template>
	<div class="form">
		<ValidationObserver
			v-slot="{ errors, invalid, handleSubmit }"
			@submit.prevent
		>
			<!-- name -->
			<h4 class="step-title">What is your name?</h4>
			<div class="step-content d-flex flex-column align-items-center">
				<div class="step-item">
					<div class="form-group mb-0 row">
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="firstName"
								name="First name"
								rules="required"
							>
								<input
									id="firstName"
									class="form-control"
									placeholder="First"
									type="text"
									v-model="lead.firstName"
								/>
							</ValidationProvider>
							<div
								class="mt-2"
								v-if="errorsExistForId(errors, 'firstName')"
							>
								<div class="alert alert-danger mb-0">
									{{ errors["firstName"][0] }}
								</div>
							</div>
						</div>
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="lastName"
								name="Last name"
								rules="required"
							>
								<input
									id="lastName"
									class="form-control"
									placeholder="Last"
									type="text"
									v-model="lead.lastName"
								/>
							</ValidationProvider>
							<div
								class="mt-2"
								v-if="errorsExistForId(errors, 'lastName')"
							>
								<div class="alert alert-danger">
									{{ errors["lastName"][0] }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- address
			<h4 class="step-title">
				<label for="zipCode">What is your address?</label>
			</h4>
			<div class="step-content d-flex flex-column align-items-center">
				<div class="step-item">
					<div class="form-group mb-0 row">
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="streetAddress"
								name="Street address"
								rules="required"
							>
								<input
									id="streetAddress"
									class="form-control"
									placeholder="Street address"
									v-on:keyup.enter="enterKeyup"
									v-model="lead.streetAddress"
								/>
							</ValidationProvider>
							<div class="mt-2">
								<div
									class="alert alert-danger"
									v-if="
										errorsExistForId(
											errors,
											'streetAddress'
										)
									"
								>
									{{ errors["streetAddress"][0] }}
								</div>
							</div>
						</div>
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="city"
								name="City"
								rules="required"
							>
								<input
									id="city"
									class="form-control"
									placeholder="City"
									v-on:keyup.enter="enterKeyup"
									v-model="lead.city"
								/>
							</ValidationProvider>
							<div class="mt-2">
								<div
									class="alert alert-danger"
									v-if="errorsExistForId(errors, 'city')"
								>
									{{ errors["city"][0] }}
								</div>
							</div>
						</div>
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="state"
								name="State"
								rules="required"
							>
								<select
									id="state"
									class="form-control"
									v-bind:class="{ placeholder: !lead.state }"
									v-model="lead.state"
								>
									<option disabled value="">State</option>
									<option
										v-for="state in states"
										v-bind:key="state.value"
										v-bind:value="state.value"
									>
										{{ state.text }}
									</option>
								</select>
							</ValidationProvider>
							<div class="mt-2">
								<div
									class="alert alert-danger"
									v-if="errorsExistForId(errors, 'state')"
								>
									{{ errors["state"][0] }}
								</div>
							</div>
						</div>
						<div class="col-12 col-md-6 mt-4">
							<ValidationProvider
								mode="eager"
								vid="zipCode"
								name="Zip code"
								rules="required|digits:5"
							>
								<input
									id="zipCode"
									class="form-control"
									placeholder="ZIP code"
									v-on:keyup.enter="enterKeyup"
									v-model="lead.zipCode"
								/>
							</ValidationProvider>
							<div class="mt-2">
								<div
									class="alert alert-danger"
									v-if="errorsExistForId(errors, 'zipCode')"
								>
									{{ errors["zipCode"][0] }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<SlotInvalidInputWatchComponent
				v-bind:invalid="invalid"
				v-bind:value="lead.zipCode"
				v-on:invalidInput="onInvalidInput"
			/> -->

			<!-- email -->
			<h4 class="step-title">
				<label for="email">What is your email?</label>
			</h4>
			<div class="step-content d-flex flex-column align-items-center">
				<div class="step-item">
					<div class="form-group mb-0 row">
						<div class="col-12 col-md-6 mx-auto">
							<ValidationProvider
								mode="eager"
								vid="email"
								name="Email"
								rules="required|email"
							>
								<input
									id="email"
									class="form-control"
									placeholder="email address"
									type="email"
									v-on:keyup.enter="enterKeyup"
									v-model="lead.email"
								/>
							</ValidationProvider>
							<div
								class="mt-2"
								v-if="errorsExistForId(errors, 'email')"
							>
								<div class="alert alert-danger">
									{{ errors["email"][0] }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<SlotInvalidInputWatchComponent
				v-bind:invalid="invalid"
				v-bind:value="lead.email"
				v-on:invalidInput="onInvalidInput"
			/>

			<!-- phone number -->
			<h4 class="step-title">
				<label for="phoneNumber">What's your phone number?</label>
			</h4>
			<div class="step-content d-flex flex-column align-items-center">
				<div class="step-item">
					<div class="form-group row">
						<div class="col-12 col-md-6 mx-auto">
							<ValidationProvider
								mode="eager"
								vid="phoneNumber"
								name="Phone number"
								rules="required|phone"
							>
								<input
									id="phoneNumber"
									class="form-control min-content-width"
									placeholder="(xxx) xxx-xxxx"
									type="tel"
									v-on:keyup.enter="enterKeyup"
									v-model="lead.phoneNumber"
								/>
							</ValidationProvider>
							<div
								class="mt-2"
								v-if="errorsExistForId(errors, 'phoneNumber')"
							>
								<div class="alert alert-danger">
									{{ errors["phoneNumber"][0] }}
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="step-item">
					<ValidationProvider
						mode="eager"
						vid="leadid_tcpa_disclosure"
						name="Consent"
						v-bind:rules="{ required: { allowFalse: false } }"
					>
						<div class="d-flex">
							<div id="consent-wrapper">
								<input
									id="leadid_tcpa_disclosure"
									type="checkbox"
									v-model="tcpaDisclosureChecked"
								/>
							</div>
							<label id="tcpa-text" for="leadid_tcpa_disclosure">
								By clicking "View My Quote", I am providing my
								electronic signature and express written consent
								to receive telemarketing calls, text messages,
								emails, and postal make from
								{{ websiteForConsent }}, this Website’s
								marketing and re-marketing network, and up to
								eight insurance companies or their affiliates or
								representatives (who are identified
								<a v-bind:href="partnersUrl" target="_blank"
									>here</a
								>) at the phone number
								{{ phoneNumberForConsent }}, email address
								{{ lead.email }}, and postal address
								{{ addressForConsent }} provided by me. I
								consent to calls and text messages transmitting
								insurance quotes, or seeking related information
								from me, and I agree such contact may be made
								using an automatic telephone dialing system
								and/or an artificial or prerecorded voice
								messages.<br /><br />
								Additionally, by clicking "View My Quote", I
								acknowledge that I have read, understand, and
								agree to this Website's
								<a
									v-bind:href="privacyPolicyUrl"
									target="_blank"
									>Privacy Policy</a
								>
								and
								<a
									v-bind:href="termsAndConditionsUrl"
									target="_blank"
									>Terms of Use</a
								>.<br /><br />
								Finally, by providing my electronic signature, I
								acknowledge that giving my consent is not a
								condition of purchasing any property, goods, or
								services, and I may revoke my consent at any
								time.
							</label>
						</div>
					</ValidationProvider>
				</div>
				<div class="step-item">
					<div
						class="alert alert-danger"
						v-if="
							!submitted &&
							errorsExistForId(errors, 'leadid_tcpa_disclosure')
						"
					>
						{{ errors["leadid_tcpa_disclosure"][0] }}
					</div>
				</div>
				<div class="step-item" v-if="!submitted && !lead.submitted">
					<button
						class="btn step-btn btn-lg form-control"
						ref="complete"
						v-on:click="handleSubmit(complete)"
					>
						View My Quote
					</button>
				</div>
				<div class="step-item">
					<div
						class="alert alert-danger"
						v-if="
							!submitted &&
							(errorsExistForId(errors, 'dateOfBirthMonth') ||
								errorsExistForId(errors, 'dateOfBirthDay') ||
								errorsExistForId(errors, 'dateOfBirthYear') ||
								errorsExistForId(errors, 'firstName') ||
								errorsExistForId(errors, 'lastName') ||
								errorsExistForId(errors, 'streetAddress') ||
								errorsExistForId(errors, 'city') ||
								errorsExistForId(errors, 'state') ||
								errorsExistForId(errors, 'zipCode') ||
								errorsExistForId(errors, 'email') ||
								errorsExistForId(errors, 'phoneNumber') ||
								errorsExistForId(
									errors,
									'leadid_tcpa_disclosure'
								))
						"
					>
						Missing or invalid answer(s)
					</div>
				</div>
				<div class="step-item" v-if="submitted && !lead.submitted">
					<div class="spinner-border" role="status">
						<span class="sr-only">Loading...</span>
					</div>
				</div>
				<div class="step-item" v-if="lead.submitted">
					<div
						class="alert alert-success"
						role="alert"
						v-if="lead.submittedSuccessfully"
					>
						Thank You! Your information has successfully been
						submitted.
					</div>
					<div class="alert alert-danger" role="alert" v-else>
						Uh oh, there was a problem submitting your information.
						Please call us to get your quote.
					</div>
				</div>
			</div>
			<SlotInvalidInputWatchComponent
				v-bind:invalid="invalid && tcpaDisclosureChecked && !submitted"
				v-bind:value="lead.phoneNumber"
				v-on:invalidInput="onInvalidInput"
			/>
		</ValidationObserver>
	</div>
</template>

<script>
import { extend } from "vee-validate";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { digits, email, required } from "vee-validate/dist/rules";
import PhoneNumber from "awesome-phonenumber";
import SlotInvalidInputWatchComponent from "../shared/SlotInvalidInputWatchComponent.vue";

extend("digits", {
	...digits,
	message: "Invalid zip code.",
});

extend("email", {
	...email,
	message: "Invalid email.",
});

extend("phone", {
	message() {
		return "Invalid phone number.";
	},
	validate(value) {
		return new Promise((resolve) => {
			// add country code
			if (value.indexOf("+1") < 0) {
				value = "+1" + value;
			}
			var phoneNumber = new PhoneNumber(value);
			resolve({ valid: phoneNumber.isValid() });
		});
	},
});

extend("required", {
	...required,
	message: "{_field_} is required.",
});

export default {
	name: "FinalQuestions",
	components: {
		ValidationProvider,
		ValidationObserver,
		SlotInvalidInputWatchComponent,
	},
	data: function () {
		return {
			days: [
				1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
				19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31,
			],
			months: [
				{ text: "January", value: 1 },
				{ text: "February", value: 2 },
				{ text: "March", value: 3 },
				{ text: "April", value: 4 },
				{ text: "May", value: 5 },
				{ text: "June", value: 6 },
				{ text: "July", value: 7 },
				{ text: "August", value: 8 },
				{ text: "September", value: 9 },
				{ text: "October", value: 10 },
				{ text: "November", value: 11 },
				{ text: "December", value: 12 },
			],
			daysByMonth: {
				1: 31,
				2: 28,
				3: 31,
				4: 30,
				5: 31,
				6: 30,
				7: 31,
				8: 31,
				9: 30,
				10: 31,
				11: 30,
				12: 31,
			},
			states: [
				{ value: "AK", text: "Alaska" },
				{ value: "AL", text: "Alabama" },
				{ value: "AR", text: "Arkansas" },
				{ value: "AZ", text: "Arizona" },
				{ value: "CA", text: "California" },
				{ value: "CO", text: "Colorado" },
				{ value: "CT", text: "Connecticut" },
				{ value: "DC", text: "District of Columbia" },
				{ value: "DE", text: "Delaware" },
				{ value: "FL", text: "Florida" },
				{ value: "GA", text: "Georgia" },
				{ value: "HI", text: "Hawaii" },
				{ value: "IA", text: "Iowa" },
				{ value: "ID", text: "Idaho" },
				{ value: "IL", text: "Illinois" },
				{ value: "IN", text: "Indiana" },
				{ value: "KS", text: "Kansas" },
				{ value: "KY", text: "Kentucky" },
				{ value: "LA", text: "Louisiana" },
				{ value: "MA", text: "Massachusetts" },
				{ value: "MD", text: "Maryland" },
				{ value: "ME", text: "Maine" },
				{ value: "MI", text: "Michigan" },
				{ value: "MN", text: "Minnesota" },
				{ value: "MO", text: "Missouri" },
				{ value: "MS", text: "Mississippi" },
				{ value: "MT", text: "Montana" },
				{ value: "NC", text: "North Carolina" },
				{ value: "ND", text: "North Dakota" },
				{ value: "NE", text: "Nebraska" },
				{ value: "NH", text: "New Hampshire" },
				{ value: "NJ", text: "New Jersey" },
				{ value: "NM", text: "New Mexico" },
				{ value: "NV", text: "Nevada" },
				{ value: "NY", text: "New York" },
				{ value: "OH", text: "Ohio" },
				{ value: "OK", text: "Oklahoma" },
				{ value: "OR", text: "Oregon" },
				{ value: "PA", text: "Pennsylvania" },
				{ value: "RI", text: "Rhode Island" },
				{ value: "SC", text: "South Carolina" },
				{ value: "SD", text: "South Dakota" },
				{ value: "TN", text: "Tennessee" },
				{ value: "TX", text: "Texas" },
				{ value: "UT", text: "Utah" },
				{ value: "VA", text: "Virginia" },
				{ value: "VT", text: "Vermont" },
				{ value: "WA", text: "Washington" },
				{ value: "WI", text: "Wisconsin" },
				{ value: "WV", text: "West Virginia" },
				{ value: "WY", text: "Wyoming" },
			],
			tcpaDisclosureChecked: false,
			submitted: false,
		};
	},
	created: function () {
		if (this.lead.dateOfBirthDay === null) {
			this.lead.dateOfBirthDay = "";
		}
		if (this.lead.dateOfBirthMonth === null) {
			this.lead.dateOfBirthMonth = "";
		}
		if (this.lead.dateOfBirthYear === null) {
			this.lead.dateOfBirthYear = "";
		}
	},
	props: {
		lead: Object,
	},
	methods: {
		onDateOfBirthSelectChange: function () {
			this.updateDays();

			// reset day if no longer valid
			if (this.lead.dateOfBirthDay) {
				if (this.days.indexOf(this.lead.dateOfBirthDay) < 0) {
					this.lead.dateOfBirthDay = "";
				}
			}
		},
		updateDays: function () {
			if (!this.lead.dateOfBirthMonth) {
				return;
			}

			var daysInMonth = this.getDaysInMonth();
			var day = this.days[this.days.length - 1];

			// add additional days
			while (day < daysInMonth) {
				day++;
				this.days.push(day);
			}

			// remove extra days
			while (day > daysInMonth + 1) {
				day = this.days.pop();
			}
		},
		getDaysInMonth: function () {
			var daysInMonth = this.daysByMonth[this.lead.dateOfBirthMonth];

			if (
				this.lead.dateOfBirthMonth == 2 &&
				this.lead.dateOfBirthYear &&
				this.lead.dateOfBirthYear % 4 == 0
			) {
				daysInMonth = 29;
			}

			return daysInMonth;
		},
		errorsExistForId: function (errors, id) {
			return errors && errors[id] && errors[id].length > 0;
		},
		validatePhoneNumber: function (value) {
			if (!value) {
				return false;
			}

			// add country code
			if (value.indexOf("+1") < 0) {
				value = "+1" + value;
			}
			var phoneNumber = new PhoneNumber(value);
			return phoneNumber.isValid();
		},
		enterKeyup: function () {
			this.$refs.complete.click();
		},
		complete: function () {
			this.$emit("complete", this.$options.name, this.lead.phoneNumber);
			this.submitted = true;
		},
		onInvalidInput: function (value) {
			this.utils.log("onInvalidInput: " + value);
			this.$emit("invalidInput", this.$options.name, value);
		},
	},
	computed: {
		years: function () {
			var years = [];
			var year = new Date().getFullYear() - 16;

			while (years.length < 84) {
				years.push(year);
				year--;
			}

			return years;
		},
		termsAndConditionsUrl: function () {
			return this.appConfig.termsAndConditionsUrl;
		},
		privacyPolicyUrl: function () {
			return this.appConfig.privacyPolicyUrl;
		},
		partnersUrl: function () {
			return this.appConfig.partnersUrl;
		},
		websiteUrl: function () {
			return this.appConfig.websiteUrl;
		},
		phoneNumberForConsent: function () {
			if (this.validatePhoneNumber(this.lead.phoneNumber)) {
				return this.lead.phoneNumber;
			}

			return "(xxx) xxx-xxxx";
		},
		addressForConsent: function () {
			if (
				this.lead.streetAddress &&
				this.lead.city &&
				this.lead.state &&
				this.lead.zipCode
			) {
				return (
					this.lead.streetAddress +
					", " +
					this.lead.city +
					", " +
					this.lead.state +
					" " +
					this.lead.zipCode
				);
			}

			return "";
		},
		websiteForConsent: function () {
			return document.location.hostname;
		},
	},
};
</script>

<style scoped>
/* address */
.placeholder {
	color: #6c757d;
}

/* phone number */
#consent-wrapper {
	margin-right: 1rem;
}

#leadid_tcpa_disclosure {
	transform: scale(1.5);
}

#tcpa-text {
	text-align: left;

	/* make sure scrollbar doesn't overlap text */
	margin-right: 1rem !important;

	/* fix for tiny checkbox on mobile safari */
	flex: 1;
}

#tcpa-text a {
	/*color: lightgrey;*/
	text-decoration: underline;
}

@media (max-width: 1023px) {
	#tcpa-text {
		font-size: 14px;
		line-height: 20px;
		margin-top: 10px;
		margin-right: 0 !important;
	}
}
</style>
